import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=ad827184&scoped=true"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"
import style0 from "./Blank.vue?vue&type=style&index=0&id=ad827184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad827184",
  null
  
)

export default component.exports